import { useCallback } from 'react';
import type { SocialBriefItemType } from '@inference.engine/widgets/web';
import { notificationService } from '@/lib/services/notification.service';
import { briefJson2Markdown } from '../../../lib/social-brief-widget.utils';
import type { UseBriefActionsReturn } from './useBriefActions.types';
import { useTranslation } from 'react-i18next';

export const useBriefActions = (brief: SocialBriefItemType): UseBriefActionsReturn => {
  const { t } = useTranslation('contentTest');

  const handleCopyMarkdown = useCallback(() => {
    try {
      const markdown = briefJson2Markdown(brief);
      void navigator.clipboard.writeText(markdown);
      notificationService.showSuccess(t('socialBriefWidget.useBriefActions.markdownCopied'));
    } catch {
      notificationService.showError(t('socialBriefWidget.useBriefActions.failedToCopyMarkdown'));
    }
  }, [brief, t]);

  return {
    handleCopyMarkdown,
  };
};
